import { cached, tracked } from '@glimmer/tracking';
import BaseController from 'uplisting-frontend/pods/base/controller';
import BookingModel from 'uplisting-frontend/models/booking';

export default class ActionBookingsSummaryController extends BaseController {
  @cached @tracked booking!: BookingModel;
}
